$(document).ready(function(){
	console.log('🐱‍💻 pimped by buero-huegel.de');
})

// WIRD AUS shop.js GETRIGGERED
function size_tooltip() {
	if (!$('label[for^="product-select-option"]:contains("Größe")').hasClass('size_label')) {
		$('label[for^="product-select-option"]:contains("Größe")').append($('.js_size_tooltip'));
	}
	$('label[for^="product-select-option"]:contains("Größe")').addClass('size_label');

	// DUMM ABER SICHER
	if (!$('label[for^="product-select-option"]:contains("Grösse")').hasClass('size_label')) {
		$('label[for^="product-select-option"]:contains("Grösse")').append($('.js_size_tooltip'));
	}
	$('label[for^="product-select-option"]:contains("Grösse")').addClass('size_label');

	if (!$('label[for^="product-select-option"]:contains("Körbchen")').hasClass('size_label')) {
		$('label[for^="product-select-option"]:contains("Körbchen")').append($('.js_size_tooltip'));
	}
	$('label[for^="product-select-option"]:contains("Körbchen")').addClass('size_label');

	if (!$('label[for^="product-select-option"]:contains("Umfang")').hasClass('size_label')) {
		$('label[for^="product-select-option"]:contains("Umfang")').append($('.js_size_tooltip'));
	}
	$('label[for^="product-select-option"]:contains("Umfang")').addClass('size_label');
	
	// TRIGGER
	generate_js_tooltip();
}

function generate_js_tooltip() {
	var text 	= $('.js_size_tooltip').data('tooltip');
	var tooltip = '<div class="js_before">'+ text +'</div>';
		
	$('.js_size_tooltip').prepend(tooltip);
	
}


// - Grösse
// - Körbchen
// - Umfang
